// @flow
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Modal from '@localytics/loc-components/lib/Modal';
import withLeaveDialog from './withLeaveDialog';
import { StandardNode, STANDARD_MESSAGE_WIDTH } from './StandardNode';
import EventNodeModal from './EventNodeModal';
import TruncatingText from './TruncatingText';
import { displayStringFromMinutes, HOUR } from '../util/TimeUtils';
import { deselectNode } from '../actions/tree';
import { modifyNode } from '../actions/api';
import { getQueryParams } from '../util/RouterUtils';

import {
  EVENT_LISTENER_ICON,
  EVENT_LISTENER_FILL_COLOR
} from '../constants/Style';

type EventNodeProps = {
  expiration_minutes: number,
  unit: string,
  selected: boolean,
  display_name: string,
  height: number,
  rx: number,
  ry: number,
  event_mapping_id: number,
  parentName: string,
  dispatch: Function,
  appsInVersion: Array<{
    app_uuid: string,
    olap_id: number
  }>,
  nodesInVersion: Object,
  currentVersionId: number,
  currentOrchestrationId: number,
  currentOrgId: number,
  appGroupId: number,
  name: string,
  parentNodeName: string,
  editable: boolean
};

export const EventNodeTitle = (props: {
  displayName: string,
  expirationMinutes: number,
  unit: string,
  parentName: string
}) => {
  const message = `Within ${displayStringFromMinutes(
    props.expirationMinutes,
    props.unit
  )} of ${props.parentName || 'previous node'}`;

  return (
    <g>
      <TruncatingText
        content={props.displayName || ''}
        maxWidth={STANDARD_MESSAGE_WIDTH}
        x={0}
        y={-14}
        fill="#555555"
        style={{
          fontSize: '16px'
        }}
      />
      <TruncatingText
        content={message}
        maxWidth={STANDARD_MESSAGE_WIDTH}
        x={0}
        y={8}
        fill="#818799"
        style={{
          fontSize: '14px'
        }}
      />
    </g>
  );
};

class EventNode extends React.Component<EventNodeProps> {
  submitForm: Function = ({
    event_mapping_id,
    attribute_group_id,
    events,
    expiration_minutes,
    unit,
    display_name,
    node_type
  }) => {
    if (!this.props.editable) {
      return;
    }
    const {
      currentVersionId: versionId,
      currentOrchestrationId: orchestrationId,
      currentOrgId: orgId,
      appGroupId,
      appsInVersion,
      nodesInVersion,
      name: nodeName
    } = this.props;
    this.props.dispatch(
      modifyNode({
        apps: appsInVersion,
        nodes: nodesInVersion,
        versionId,
        orchestrationId,
        orgId,
        appGroupId,
        nodeName,
        newNodeData: {
          event_mapping_id,
          attribute_group_id,
          events,
          expiration_minutes,
          unit,
          display_name,
          node_type
        }
      })
    );
    this.props.dispatch(deselectNode());
  };
  cancelForm: Function = () => this.props.dispatch(deselectNode());
  closeForm: Function = () => this.props.dispatch(deselectNode());
  render() {
    const {
      currentOrgId,
      currentVersionId,
      currentOrchestrationId,
      expiration_minutes: expirationMinutes = 60,
      unit: unit = HOUR,
      selected,
      display_name: displayName,
      height,
      rx,
      ry,
      event_mapping_id: eventMappingId,
      parentName,
      parentNodeName,
      editable
    } = this.props;
    const ModalWithLeaveDialog = editable ? withLeaveDialog(Modal) : Modal;
    return (
      <StandardNode
        height={height}
        rx={rx}
        ry={ry}
        icon={EVENT_LISTENER_ICON}
        iconFill={EVENT_LISTENER_FILL_COLOR}
      >
        <ModalWithLeaveDialog show={selected} onHide={() => {}}>
          <EventNodeModal
            currentOrgId={currentOrgId}
            currentVersionId={currentVersionId}
            currentOrchestrationId={currentOrchestrationId}
            expiration_minutes={expirationMinutes}
            unit={unit}
            event_mapping_id={eventMappingId}
            height={height}
            rx={rx}
            ry={ry}
            parentName={parentName}
            submitFormCallback={this.submitForm}
            cancelCallback={this.cancelForm}
            closeCallback={this.closeForm}
            editable={editable}
          />
        </ModalWithLeaveDialog>
        <EventNodeTitle
          displayName={displayName}
          expirationMinutes={expirationMinutes}
          unit={unit}
          parentName={parentNodeName}
        />
      </StandardNode>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    orgId: currentOrgId,
    orchestrationId: currentOrchestrationId,
    versionId: currentVersionId
  } = getQueryParams(ownProps.location);
  const { api: { versionsByOrchestrationId } } = state;
  const version =
    versionsByOrchestrationId[currentOrchestrationId][currentVersionId] || {};
  const { nodes: { [ownProps.parentName]: parent = {} } = {} } = version;
  return {
    appsInVersion: version.apps,
    nodesInVersion: version.nodes,
    appGroupId: version.app_group_id,
    currentOrgId,
    currentVersionId,
    currentOrchestrationId,
    parentNodeName: parent.display_name || parent.node_type
  };
};

const ConnectedEventNode = withRouter(connect(mapStateToProps)(EventNode));

export { ConnectedEventNode as EventNode };



// WEBPACK FOOTER //
// ./src/components/EventNode.jsx